<template>
  <div>
  <v-row align="center" class="pa-4">
      <v-card-title class="pb-4 pr-8">Журнал проезда автомобиля клиента</v-card-title>
      <v-spacer></v-spacer>
  </v-row>
    <v-col cols="12" sm="7" md="8" lg="7" class="py-0 mb-6">
      <v-row class="mb-2" style="">
        <v-menu
          v-model="menuFilterDate"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="230px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="dateRangeFilter"
              label="Промежуток времени"
              outlined
              dense
              hide-details
              style="max-width: 360px;"
              class="input input-search mr-2 pl-3"
              v-on="on"
              prepend-inner-icon="mdi-calendar"
              readonly
            ></v-text-field>
          </template>
          <v-date-picker v-model="dateFilter" @click="menuFilterDate = false" range :max="today">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Назад
            </v-btn>
            <v-btn text color="primary" :disabled="!dateFilter[0]" @click="dateFilter = []">
              Сбросить
            </v-btn>
            <v-btn text color="primary" @click="menuFilterDate = false">
              Выбрать
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-btn
          :disabled="!dateFilter[1]"
          :style="isMobile ? 'margin-top: 10px;' : ''"
          @click="loadJournalGrz"
          class="btn primary white px-7 text-none ml-4"
        >
          Поиск
        </v-btn>
      </v-row>
    </v-col>
    <v-data-table
      class="table"
      :headers="HeadersJournal"
      :items="responseJournal"
    >
      <template v-slot:item.createdAt="{item}">
        {{ ruDateFormat(item.date) }}
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn color="primary" @click="loadImage(item.date)">
          Фотография
        </v-btn>
      </template>
      <template v-slot:item.opening_info="{ item }">
        <div v-if="item.opening_info === '-\r'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                width="18"
                height="18"
              >
                <v-icon x-small color="red">mdi-checkbox-blank-circle</v-icon>
              </v-btn>
            </template>
            <span>Номер был распознан, но его нет в базе данных.</span>
          </v-tooltip>
        </div>
        <div v-if="item.opening_info === '+\r'">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                width="18"
                height="18"
              >
                <v-icon x-small color="green">mdi-checkbox-blank-circle</v-icon>
              </v-btn>
            </template>
            <span>Номер был распознан и находится в нашей базе данных.</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog" :max-width="isMobile ? '90%' : '50%'" @input="dialog = false">
      <zoom-photo
        v-model="dialog"
        :photo="imageSrc"
        @closeZoomPhoto="dialog = false"
      >
      </zoom-photo>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import zoomPhoto from '../../../client/DetailClient/components/zoomPhoto';

export default {
  name: 'CallLogClient',
  mixins: [ruDateFormatMixin],
  components: { zoomPhoto },
  props: ['id'],
  data () {
    return {
      isMobile: false,
      loading: false,
      dialog: false,
      today: new Date().toISOString().split('T')[0],
      menuFilterDate: false,
      prod: false,
      dateFilter: [],
      uniqueBarriers: [],
      base64Image: '',
      startDate: '',
      endDate: '',
      carNumbersInfo: [],
      barriersInfo: [],
      responseJournal: [],
      include: ['abonents.doorphones,abonents.keys,abonents.apartment_sip_settings'],
      HeadersJournal: [
        { text: 'Дата и время', value: 'createdAt', align: 'center' },
        { text: 'Номер автомобиля', value: 'car_number', sortable: false, align: 'center' },
        { text: 'Распознание грз', value: 'opening_info', sortable: false, align: 'center' },
        { text: '', value: 'action', sortable: false, width: '8%', align: 'center' },
      ],
    };
  },
  created () {
    if (this.client.abonents.length) {
      this.carNumbersInfo = this.client.abonents
        .map(abonent => abonent.car_number).flat()
        .filter(carNumber => carNumber !== null);

      this.barriersInfo = this.client.abonents
        .flatMap(abonent => abonent.doorphones.flatMap(doorphone => doorphone.barriers.map(barrier => barrier.id)))
        .filter((id, index, self) => self.indexOf(id) === index);

      if (this.carNumbersInfo.length > 0) {
        this.loadJournalGrz();
      } else {
        this.$flash_danger('У клиента не присвоен гос номер автомобиля.');
      }
    } else {
      this.getData();
    }
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
    if (this.dateFilter.length === 0) {
      const today = new Date().toISOString().split('T')[0];
      this.dateFilter = [today, today];
    }
  },
  computed: {
    ...mapGetters({
      client: 'Client/client',
    }),
    imageSrc () {
      return `data:image/jpeg;base64,${this.base64Image}`;
    },
    dateRangeFilter () {
      let formattedStartDate = '';
      let formattedEndDate = '';
      if (this.dateFilter[0]) {
        formattedStartDate = this.ruDateFormat(this.dateFilter[0], true);
      }
      if (this.dateFilter[1]) {
        formattedEndDate = ` - ${this.ruDateFormat(this.dateFilter[1], true)}`;
      }

      return `${formattedStartDate}${formattedEndDate}`;
    },
  },
  methods: {
    ...mapActions({
      loadClient: 'Client/loadClient',
      getJournalGrzOpen: 'Barriers/getJournalGrzOpen',
      getImageJournalGrz: 'Barriers/getImageJournalGrz',
    }),
    getData () {
      this.loadClient({
        id: this.$route.params.id,
        options: {
          include: this.include,
        },
      }).then(response => {
        this.carNumbersInfo = response.data.abonents
          .map(abonent => abonent.car_number).flat()
          .filter(carNumber => carNumber !== null);

        this.barriersInfo = response.data.abonents
          .flatMap(abonent => abonent.doorphones.flatMap(doorphone => doorphone.barriers.map(barrier => barrier.id)))
          .filter((id, index, self) => self.indexOf(id) === index);

        if (this.carNumbersInfo.length > 0) {
          this.loadJournalGrz();
        }
      });
    },
    loadImage (dateTime) {
      let formattedDateTime = dateTime;
      if (typeof dateTime === 'string') {
        const match = dateTime.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}/);
        if (match) {
          formattedDateTime = match[0];
        }
      }
      const requests = this.barriersInfo.map(barrierId =>
        this.getImageJournalGrz({
          id: barrierId,
          dateTime: formattedDateTime,
        }),
      );

      Promise.all(requests)
        .then(responses => {
          // первое успешное изображение
          const firstSuccessfulResponse = responses.find(response => response.status === 200);

          if (firstSuccessfulResponse) {
            this.base64Image = firstSuccessfulResponse.data;
            this.dialog = true;
          } else {
            this.$flash_warning('Не удалось получить изображение журнал грз.');
          }
        })
        .catch(err => {
          console.error(err);
          this.$flash_warning('Не удалось получить изображение журнал грз.');
        });
    },
    async loadJournalGrz () {
      // если дата не указана то автоматически подставляется текущий день
      if (this.dateFilter[1]) {
        this.startDate = this.dateFilter[0] + ' 00:00:00';
        this.endDate = this.dateFilter[1] + ' 23:59:59';
      }
      this.loadingList = true;

      try {
        const requests = this.barriersInfo.map(barrierId =>
          this.getJournalGrzOpen({
            id: barrierId,
            startDate: this.startDate,
            endDate: this.endDate,
            sort: this.sort,
            carNumbers: this.carNumbersInfo,
          }),
        );
        const responses = await Promise.all(requests);

        this.responseJournal = responses.flatMap(response => response.data.data);
      } catch (err) {
        console.error(err);
        this.$flash_warning('Не удалось получить журнал грз. Нет записей.');
      } finally {
        this.loadingList = false;
      }
    },
  },
};
</script>
